import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Checkbox } from 'material-ui';
import FormField from '../../shared/components/FormField';
import { I18nUtils } from '../../../i18n/I18nUtils';
import Alert from 'react-s-alert';

export default class SchemeDocumentsFormDocumentTypesSubForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            availableDocumentTypes: props.documentTypes,
        };
    }

    componentWillReceiveProps(props) {
        if ( this.state.availableDocumentTypes !== props.documentTypes ) {
            this.setState({
                availableDocumentTypes: props.documentTypes,
            });
        }

        if ( this.props.schemaType !== -1 && props.schemaType !== this.props.schemaType ) this.props.fields.removeAll();
    }

    onDocumentTypeAdd() {
        const selectedDocumentType = this.refs.documentTypeSelect.options[this.refs.documentTypeSelect.selectedIndex];

        let isAdded = false;
        if ( this.props.fields && this.props.fields.getAll() ) {
            this.props.fields.getAll().forEach((field) => {
                if ( parseInt(field.id, 0) === parseInt(selectedDocumentType.value, 0) ) {
                    isAdded = true;
                }
            });
        }

        if ( !isAdded ) {
            if ( selectedDocumentType.value > -1 ) {
                this.props.fields.push({
                    id: selectedDocumentType.value,
                    name: selectedDocumentType.text,
                    required: true,
                    optional: false,
                });
            }
        } else {
            Alert.error(I18nUtils.tr('TR_EL_DOCUMENTO_YA_SE_HA_ANADIDO'));
        }
    }

    onDocumentTypeRemove(index) {
        this.props.fields.remove(index);
    }

    renderField(field) {
        return <FormField field={field}/>;
    }

    renderCheckbox({ input, label, ...rest }) {
        return (
            <Checkbox
                {...input}
                {...rest}
                label={label}
                checked={input.value ? true : false}
                onCheck={input.onChange}
                iconStyle={{ fill: '#607D8B', marginRight: '2px' }}
                style={{ width: 'auto', float: 'left', top: '2px' }}
            />
        );
    }

    render() {
        // console.error('DocumentTypesForm props', this.props);

        const { fields, meta: { error, submitFailed } } = this.props;

        return (
            <div>
                <div className="row">
                    <div className="col-lg-8">
                        <div className="form-group">
                            <select
                                test-id="form-select-document-type"
                                ref="documentTypeSelect"
                                className="form-control show-tick bootstrap-select"
                            >
                                <option key={-1} value={-1}>Indica un tipo de documento</option>
                                {this.state.availableDocumentTypes.map((object, i) => {
                                    return ( <option key={i} value={object.value}>{object.name}</option> );
                                })}
                            </select>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="form-group">
                            <button
                                test-id="form-add-document-type"
                                type="button"
                                className="btn btn-default btn-block btn-sm waves-effect"
                                onClick={this.onDocumentTypeAdd.bind(this)}
                            >
                                Añadir otro
                            </button>
                        </div>
                    </div>
                    <div className="col-xs-12">
                        {submitFailed && error &&
                            <div className="form-group"><label className="error">{error}</label></div>}
                    </div>
                </div>
                {
                    fields.map((member, index, fields) => (
                        <div className="row" key={index}>
                            <div className="col-xs-8">
                                <Field
                                    name={`${member}.name`}
                                    type="text"
                                    component={this.renderField}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-xs-4">
                                <div className="form-group">
                                <span className="another-select" style={{ float: 'left' }}>
                                    <a onClick={() => this.onDocumentTypeRemove(index)}>
                                        <i className="material-icons">clear</i>
                                    </a>
                                </span>
                                    <Field
                                        name={`${member}.optional`}
                                        type="checkbox"
                                        component={this.renderCheckbox}
                                        label={I18nUtils.tr('TR_OPCIONAL')}
                                    />
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        );
    }

}

SchemeDocumentsFormDocumentTypesSubForm.propTypes = {
    documentTypes: PropTypes.array,
};

SchemeDocumentsFormDocumentTypesSubForm.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/documents/components/SchemeDocumentsFormDocumentTypesSubForm.jsx